import React from "react"

function InquiriesOrder() {
  return (
    <div className="uk-text-center uk-flex uk-flex-column uk-padding bg-gray">
      <h3 className="uk-margin-remove">For any orders or inquiries</h3>
      <div className="uk-text-middle uk-flex uk-flex-center uk-flex-middle uk-padding-small uk-padding-remove-bottom">
        <span uk-icon="icon: whatsapp" className="uk-margin-small-right"></span>
        <p className="uk-margin-remove">+62 819 0278 2721</p>
      </div>
    </div>
  )
}

export default InquiriesOrder
